import { useTranslation } from "react-i18next";
import {
  useTransferDraft,
  useTransferDraftDispatch,
} from "../../../../providers/transferDraft";
import { TextField } from "@mui/material";
import { TransferDraftActionType } from "../../../../reducers/transferDraft";
import { fixedFieldSx } from "./fixedFieldSx";

type SubjectTextFieldProps = {
  disabled?: boolean;
};

export default function SubjectTextField({ disabled }: SubjectTextFieldProps) {
  const transferDraft = useTransferDraft();
  const transferDraftDispatch = useTransferDraftDispatch();
  const { t } = useTranslation();

  return (
    <TextField
      sx={fixedFieldSx}
      disabled={disabled}
      value={transferDraft.subject}
      variant="filled"
      type="text"
      label={t(`Subject`)}
      InputProps={{
        disableUnderline: true,
      }}
      onChange={(newValue) =>
        transferDraftDispatch({
          type: TransferDraftActionType.subjectUpdate,
          updatedSubject: newValue.target.value,
        })
      }
    />
  );
}
